import Vue from 'vue'

// axios
import axios from 'axios'

 let baseDonmain = 'https://api.promptsung.co'
 let omsDonmain = 'https://oms-api.promptsong.co'

//let baseDonmain = 'https://uat-api-marketplace-frontend.azurewebsites.net'
// let omsDonmain = 'https://uat-oms-api.azurewebsites.net'

// baseDonmain = 'https://localhost:5001'

console.log(window.location.origin)

// if (
//   window.location.origin === 'https://seller.promptsung.co'
//   || window.location.origin === 'http://seller.promptsung.co'
// ) {
//   baseDonmain = 'https://api.promptsung.co'
//   omsDonmain = 'https://oms-api.promptsong.co'
// }


export const baseURL = `${baseDonmain}`
export const omsURL = `${omsDonmain}`

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
